import {SelectValidator, TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import localization from "../../../config/localization";
import React from "react";
import {DateTimePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import {Event} from "@material-ui/icons";
import moment from "moment";
import {Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup} from "@material-ui/core";
import FilePondUploader from "../../../components/Letflow/FilePondUploader";
import {ErrorMessage} from "formik";
import styled from "styled-components";
import {ImagePicker, VideoPicker} from "../../../components/Letflow/Form";
import AsyncSelect from "react-select/lib/Async";
import {request} from "../../../api-client";

const FormView = (formikProps) => {
  const {values, handleChange, setFieldValue, handleSubmit, resetForm} = formikProps
  return (
    <div style={{padding: '0 25px'}}>
      <ValidatorForm onSubmit={() => handleSubmit()}>

      <TextValidator
        style={{ width: "100%", marginBottom: "20px" }}
        id="name"
        label={localization.get('form.name')}
        name="name"
        value={values.name}
        onChange={handleChange}
        validators={['required']}
        errorMessages={[localization.get('validator.is_required')]}
      />


      <div style={{margin: '20px 0 5px', float: 'right'}}>
        <Button onClick={() => values.handleCloseForm(resetForm)} color='default'>{localization.get("cancel")}</Button>
        <Button type="submit" color='info' disabled={values.disabled}>{localization.get("form.save")}</Button>
      </div>
      </ValidatorForm>
    </div>
  )
}

export default FormView

const DateDiv = styled.div`
  display: inline-flex;
  flex-direction: column;
`
